import { useCallback, useEffect } from 'react';

import { debounce } from 'lodash-es';

import { useDevice } from '@contexts/device';

const alphaRegex = /^[a-zA-ZğüşöçıİĞÜŞÖÇI]+$/;
export type ItemType = {
  id: number;
  name: string;
};

export const useHighLightDropDownItem = ({
  items,
  isOpen,
  setHighlightedIndex,
}: {
  items: ItemType[];
  isOpen: boolean;
  setHighlightedIndex: (index: number) => void;
}) => {
  const { isDesktop } = useDevice();

  const handleKeyDown: (this: Document, ev: KeyboardEvent) => any = useCallback(
    (event) => {
      if (!isDesktop) return;
      if (event?.key?.length > 1) return;
      if (items?.length < 10) return;
      if (!isOpen) return;

      if (alphaRegex.test(event.key)) {
        const targetItem = ([...items] as ItemType[])?.find((item) =>
          item.name
            ?.toLocaleLowerCase('tr-TR')
            .startsWith(event.key?.toLocaleLowerCase('tr-TR'))
        );

        if (targetItem) {
          setHighlightedIndex(items?.indexOf(targetItem) ?? -1);
        }
      }
    },
    [isOpen, items, setHighlightedIndex, isDesktop]
  );

  useEffect(() => {
    document.addEventListener('keydown', debounce(handleKeyDown, 200), false);

    return () => {
      document.removeEventListener('keydown', handleKeyDown, false);
    };
  }, [handleKeyDown]);
};
